/**
 * Created by Gal Weissman 22/10/17
 */
import IService from '../IService';
import app from '#/app';
import { initializeApp } from 'firebase/app';
import {
  browserSessionPersistence,
  getAuth,
  setPersistence,
  signInWithCustomToken,
} from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import _ from 'lodash-extended';

export default IService.extend({
  _tokenFields: ['token', 'domainUrl', 'apiKey', 'userId'],

  _fetchToken({ type, id }) {
    return new Promise((resolve, reject) => {
      let postData = undefined;
      if (type === 'storyId') {
        postData = { storyId: id };
      }

      $.ajax({
        url: app.apiUrl('/api/v2/fe-stash/token'),
        type: 'GET',
        data: postData,

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success: (res) => {
          const fields = this._tokenFields;
          const ok = _.every(fields, (field) => {
            return (
              Object.getOwnPropertyDescriptor(res, field) &&
              _.isDefined(res[field])
            );
          });
          ok ? resolve(res) : reject('invalid response format');
        },
      });
    });
  },

  authenticate({ type, id }) {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        reject('TIMEOUT');
      }, app.TIME.minute(2));

      this._fetchToken({ type, id }).then((firebaseConfig) => {
        const fbApp = initializeApp(
          {
            databaseURL: firebaseConfig.domainUrl,
            apiKey: firebaseConfig.apiKey,
          },
          `stash[${type}](read/write)`
        );
        const auth = getAuth(fbApp);

        setPersistence(auth, browserSessionPersistence).then(() => {
          signInWithCustomToken(auth, firebaseConfig.token).then(() => {
            clearTimeout(timeout);

            const fbdb = getDatabase(fbApp);
            resolve({
              fbdb,
              userId: firebaseConfig.userId,
            });
          }, reject);
        }, reject);
      }, reject);
    });
  },
});
